// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"366": "9154912f","484": "b042d9ef","654": "ef611aab","985": "482cb750",}[chunkId] + ".css"
}